import React, { useEffect, useState } from 'react';
import Heading from '../../../../components/heading/Heading';
import { HEADING } from '../../../../components/heading/constants/constants';
import importSectionStyles from '../../ImportSection.styles';
import { componentKey } from './QboSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getFormLabels, getFormSetting, getLoadImportData } from './QboSaga';
import FormBoxesCard from '../../../../components/card/formboxescard/FormBoxesCard';
import MultiSelectDropdown from '../../../../components/multiselect/multiselectdropdown/MultiSelectDropdown';
import Button from '../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import { INTEGRATION_CONSTANTS, SOURCE_CONSTANTS, FORM_IDS, QBO_LOADING_STATES, QBO_LOADING_STATES_MESSAGE_MAP } from '../constants';
import ImportDataGridView from '../../../components/importdatagridview/ImportDataGridView';
import Loadable from '../../../../components/loadable/Loadable';
import Popup from '../../../../components/popup/Popup';
import qboStyles from './Qbo.styles';

export default function QboMatchFields({ qboCOAOptions, formType, taxYear, realmId }) {
    const [formCheckBoxesDropdownLabels, setFormCheckBoxesDropdownLabels] = useState([]);
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const [selectedDropdownOptions, setSelectedDropdownOptions] = useState([]);
    const [qboMatchFields, setQboMatchFields] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [initialLength, setInitialLength] = useState(0);
    const { formBoxLabels, importData, formSettings, isImportDataGridViewLoaded, loadingState } = useSelector(state => state[componentKey]);
    const dispatch = useDispatch();

    useEffect(() => {
        const updatedQboMatchFields = selectedDropdownOptions.reduce((accumulator, dropdown, index) => {
            const options = dropdown.map((option) => ({ COAType: option.value, BoxNo: index + 1 }));
            return accumulator.concat(options);
        }, []);

        setQboMatchFields(updatedQboMatchFields);
    }, [selectedDropdownOptions]);


    useEffect(() => {
        dispatch(getFormLabels());
    }, []);

    useEffect(() => {
        setSelectedDropdownOptions(Array.from({ length: initialLength }, () => []));
    }, [initialLength]);

    useEffect(() => {
        if (formBoxLabels && formBoxLabels[formType]) {
            const initialDropdownOptions = formBoxLabels[formType].map((_) => {
                const matchingOptions = qboCOAOptions.map(option => ({
                    label: option.Text,
                    value: option.Value,
                    checked: false,
                    disabled: false
                }));
                return matchingOptions;
            });
            setFormCheckBoxesDropdownLabels(formBoxLabels[formType]);
            setDropdownOptions(initialDropdownOptions);
            setInitialLength(formBoxLabels[formType].length);
        }
    }, [formBoxLabels, formType]);

    useEffect(() => {
        if (importData) {
            dispatch(getFormSetting({ formId: formType, year: taxYear }));
        }
    }, [importData]);


    const closePopup = () => {
        setIsPopupOpen(false);
    };

    const handleCategoriesChooseLinkButtonClick = () => {
        setIsPopupOpen(true);
    };

    const handleSelectOrUnSeclectAll = () => {
        const allChecked = formCheckBoxesDropdownLabels.every((checkbox) => checkbox.Checked);
        setFormCheckBoxesDropdownLabels(
            formCheckBoxesDropdownLabels.map((checkbox) => ({ ...checkbox, Checked: !allChecked }))
        );
        updateDropdownOptionsWhenUnseletedSelectAll();
    };

    const handleLeftBoxCheckbox = (index) => {
        const updatedcheckBoxesDropdownLabels = formCheckBoxesDropdownLabels.map((checkbox, i) => {
            if (index === i) {
                return { ...checkbox, Checked: !checkbox.Checked };
            }
            return checkbox;
        });
        if (selectedDropdownOptions.length > 0) {
            const selectedOptions = selectedDropdownOptions[index];
            const selectedvalues = selectedOptions.map(option => option.value);
            if (selectedvalues) {
                const updatedDropdownOptions = updateUnSelectedDropdownOption(index, selectedvalues);
                setDropdownOptions(updatedDropdownOptions);
            }
        }

        setFormCheckBoxesDropdownLabels(updatedcheckBoxesDropdownLabels);
    };

    const updateDropdownOptionsWhenUnseletedSelectAll = (() => {
        const updatedDropdownOptions = dropdownOptions.map((individualDropdown, i) => {
            return individualDropdown.map(option => ({
                ...option,
                checked: false,
                disabled: false
            }));
        });
        return setDropdownOptions(updatedDropdownOptions);
    })

    const updateUnSelectedDropdownOption = ((index, unSelectedDropdownOptionValue) => {

        const updatedDropdownOptions = dropdownOptions.map((individualDropdown, i) => {
            const isCurrentIndex = i === index;
            return individualDropdown.map(option => ({
                ...option,
                checked: isCurrentIndex ? (option.checked && unSelectedDropdownOptionValue.includes(option.value) ? false : option.checked) : option.checked,
                disabled: !isCurrentIndex ? (option.disabled && unSelectedDropdownOptionValue.includes(option.value) ? false : option.disabled) : option.disabled
            }));
        });
        return updatedDropdownOptions;
    })
    const updateSelectedDropdownOption = ((index, selectedDropdownOptionValue) => {

        const updatedDropdownOptions = dropdownOptions.map((individualDropdown, i) => {
            const isCurrentIndex = i === index;
            return individualDropdown.map(option => ({
                ...option,
                checked: isCurrentIndex ? (selectedDropdownOptionValue.includes(option.value)) : option.checked,
                disabled: !isCurrentIndex ? (option.disabled || selectedDropdownOptionValue.includes(option.value)) : option.disabled
            }));
        });
        return updatedDropdownOptions;
    })

    const handleDropdownOptionsSelected = (index, options) => {

        if (options.length === 0) {
            const unSelectedLastDropdownOption = selectedDropdownOptions[index];
            const unSelectedLastDropdownOptionValue = unSelectedLastDropdownOption.map(option => option.value);
            const updatedDropdownOptions = updateUnSelectedDropdownOption(index, unSelectedLastDropdownOptionValue);
            return setDropdownOptions(updatedDropdownOptions);
        }
        setDropdownOptions(prevOptions => {
            const updatedOptions = [...prevOptions];
            updatedOptions[index] = options;
            return updatedOptions;
        });
        const selectedOptions = options.filter(option => option.checked === true);
        if (selectedOptions.length > 0) {
            setSelectedDropdownOptions(prevDropdownOptions => {
                const updatedDropdownOptions = [...prevDropdownOptions];
                updatedDropdownOptions[index] = selectedOptions;
                return updatedDropdownOptions;
            });
            if (selectedDropdownOptions[index] && options.length < selectedDropdownOptions[index].length) {
                const unSelectedOptions = selectedDropdownOptions[index]
                    .filter(selectedOption => !options.some(option => option.value === selectedOption.value));
                const unSelectedValue = unSelectedOptions.map(option => option.value);
                const updatedDropdownOptions = updateUnSelectedDropdownOption(index, unSelectedValue);
                return setDropdownOptions(updatedDropdownOptions);
            }
            const selectedValues = selectedOptions.map(option => option.value);
            const updatedDropdownOptions = updateSelectedDropdownOption(index, selectedValues);
            return setDropdownOptions(updatedDropdownOptions);
        }
    };

    return (
        <>
            {(formSettings && taxYear && formType && isImportDataGridViewLoaded) ? (
                <ImportDataGridView
                    isStateFilingApplicable={false}
                    filingForCorrected={false}
                    formSettings={formSettings}
                    formName={formType}
                    formId={
                        (() => {
                            switch (formType) {
                                case INTEGRATION_CONSTANTS.NEC_FORM:
                                    return FORM_IDS.$1099NEC;
                                case INTEGRATION_CONSTANTS.MISC_FORM:
                                    return FORM_IDS.$1099MISC;
                                default:
                                    return null;
                            }
                        })()
                    }
                    taxYear={taxYear}
                />
            ) : (
                <Loadable
                    currentState={loadingState.state}
                    loadingStates={QBO_LOADING_STATES.MATCHFIELDS_LOADING}
                    messageMap={QBO_LOADING_STATES_MESSAGE_MAP}
                    isNewLoadable={true}
                >
                    {
                        isPopupOpen && <Popup
                            title="Which categories to choose?"
                            isPopupOpen={isPopupOpen}
                            onCloseCb={closePopup}
                            customPopupSyles={qboStyles.popupContainer}
                        >
                            <>
                                <p style={qboStyles.popupParagraph}>
                                    1. Here displays all the accounts (from your QuickBooks chart of accounts) you used to pay the vendors you marked as 1099 vendors.
                                    Check the box where payments from the QuickBooks account should be reported, Click the drop-down arrow to select the list of accounts.
                                </p>
                                <p style={qboStyles.popupParagraph}>
                                    2. You can assign multiple accounts to a 1099 box, but each account can be assigned to only one 1099 box.
                                    For example, if you set up an expense account named "Payments to Subcontractors," you can assign it to Box 1: Nonemployee compensation on form 1099 NEC.
                                    However, you can't use the Payments to Subcontractors expense account for any other 1099 category.
                                </p>
                            </>
                        </Popup>
                    }
                    <div style={importSectionStyles.mainContainer}>
                        <div style={importSectionStyles.titleRow}>
                            <div style={importSectionStyles.headerTitle}>
                                <Heading
                                    type={HEADING.H1}>
                                    Pick all the categories that apply to your vendors and then tell us which QuickBooks accounts you use to track the payments.
                                </Heading>
                                <Button
                                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                    onClickCb={handleCategoriesChooseLinkButtonClick}
                                >
                                    Not sure which categories to choose?
                                </Button>
                            </div>
                            <div style={importSectionStyles.nextButtonMargin}>
                                <Button onClickCb={() => dispatch(getLoadImportData(
                                    {
                                        integrationImportRequestDto: {
                                            TaxYear: taxYear,
                                            FormName: formType,
                                            BusinessId: realmId,
                                            Source: SOURCE_CONSTANTS.QBO_SOURCE,
                                            MatchFieldsData: qboMatchFields
                                        }
                                    }))
                                }>Next</Button>
                            </div>
                        </div>
                        <div style={importSectionStyles.boxListContainer}>
                            <div style={importSectionStyles.boxListRow}>
                                <div style={importSectionStyles.tobeSelectedBoxesContainer}>
                                    <Button
                                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                        onClickCb={handleSelectOrUnSeclectAll}
                                        title="selectAllCheckbox"
                                    > Select All/UnSelect All
                                    </Button>
                                    {formCheckBoxesDropdownLabels.map((item, index) => (
                                        <div key={index}>
                                            <FormBoxesCard
                                                boxCheckbox={{
                                                    showCheckbox: true,
                                                    isChecked: item.Checked,
                                                    onChangeCb: () => handleLeftBoxCheckbox(index)
                                                }}
                                                boxData={{ boxNumber: index + 1, boxLabel: item.Label }}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <div style={importSectionStyles.selectedBoxesValuesContainer}>
                                    {formCheckBoxesDropdownLabels.map((item, index) => (
                                        <div key={index}>
                                            {item.Checked && (
                                                <MultiSelectDropdown
                                                    key={index}
                                                    label={item.Label}
                                                    options={dropdownOptions[index] || []}
                                                    onSelectOptionsCb={(options) => handleDropdownOptionsSelected(index, options)}
                                                    isSelectAllDisabled = {true}
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <Button onClickCb={() => dispatch(getLoadImportData(
                                    {
                                        integrationImportRequestDto: {
                                            TaxYear: taxYear,
                                            FormName: formType,
                                            BusinessId: realmId,
                                            Source: SOURCE_CONSTANTS.QBO_SOURCE,
                                            MatchFieldsData: qboMatchFields
                                        }
                                    }))
                                }>Next</Button>
                            </div>
                        </div>
                    </div>
                </Loadable>
            )}
        </>
    );
}
